import React from 'react'
import PropTypes from 'prop-types'
import OpalHeading from '../../../../components/opal/OpalHeading'
import FlexRow from '../../../../components/molecules/FlexRow'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import { useFormattingContext } from '../../../../components/organisms/FormattingProvider/FormattingContext'
import LinkCard from '../common/LinkCard'

function ReadingListMenuItem ({ scheduledPrompt }) {
  const { formatter } = useFormattingContext()
  return (
    <LinkCard to={`/denali-ai/reading-list/item/${scheduledPrompt.scheduleId}`}>
      <FlexColumn className='gap-sm'>
        <FlexRow>
          <OpalHeading className='font-size-md'>{scheduledPrompt.name}</OpalHeading>
        </FlexRow>
        <FlexRow>
          <span className='font-sans font-size-xs'>{formatter(scheduledPrompt.instanceDate, 'tradeDate')}</span>
        </FlexRow>
      </FlexColumn>
    </LinkCard>
  )
}

ReadingListMenuItem.propTypes = {
  scheduledPrompt: PropTypes.shape({
    scheduleId: PropTypes.string,
    name: PropTypes.string,
    instanceDate: PropTypes.string
  })
}

export default ReadingListMenuItem
